export default __webpack_public_path__ + "static/media/scale.ca146980.png";